import React, { useState } from 'react'
import StatusList from './StatusList'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'

function Status() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<StatusList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default Status